var map = {
	"./Austria_BMK_Logo_srgb_EN.png": 5616,
	"./Finland_Vayla.png": 9672,
	"./Germany_Federal Ministry of Transport and Digital Infrastructure.png": 4055,
	"./Hungary__kismeretu_Hungary Public Roads.jpg": 8377,
	"./Ireland_transport-infrastructure-ireland.png": 974,
	"./Netherlands_RWS.png": 9660,
	"./Sweden_TV_logo_RGB_Eng.jpg": 3738,
	"./UK_National-highways_logo.svg.png": 6711,
	"./belgium_wallonia.png": 1576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5;